const actions = {
    GET_ORDER_LIST:'GET_ORDER_LIST',
    SET_ORDER_LIST:' SET_ORDER_LIST',
    GET_ORDER_DETAILS: 'GET_ORDER_DETAILS',
    SET_ORDER_DETAILS: 'SET_ORDER_DETAILS',  
    RE_ORDER: 'RE_ORDER',
 }
 export default actions;